// extracted by mini-css-extract-plugin
export default {"nologin":"Setup_nologin__Arte6","blank":"Setup_blank__BViuQ","blank_img":"Setup_blank_img__VfzDV","text":"Setup_text__lZq9v","right_control":"Setup_right_control__pteEZ"};